module.exports = __webpack_public_path__ + "static/blue-bg-645a7e4191aa64be9244dad43652c047.png";